var directions = [
    0,
    90,
    180,
    270
]

var fruitList = [
    "strawberry",
    "lemon",
    "2strawberry",
    "3strawberry",
    "4strawberry"
]

var colorList = [
    "circle-red",
    "circle-green",
    "circle-blue",
    "circle-yellow",
    "circle-orange",
    "circle-pink",
    "circle-purple",
    "circle-black"
]

var shapeList = [
    "triangle-red",
    "triangle-green",
    "triangle-blue",
    "rectangle-red",
    "rectangle-green",
    "rectangle-blue",
    "cross-red",
    "cross-green",
    "cross-blue"
]

var houseList = [
    "house-pink",
    "house-green",
    "house-blue"
]

var movableBoxesList = [
    "movablebox",
    "destinationbox"
]



// WEBPACK FOOTER //
// src/app/lib/specialObjectsList.js